// Lightweight WebAudio sound engine (no external assets).
let ctx = null;
let master = null;
let muted = localStorage.getItem("mathrush_muted") === "1";
let musicNode = null;
let musicTimer = null;
let musicStep = 0;

function ensure() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
    master = ctx.createGain();
    master.gain.value = muted ? 0 : 0.5;
    master.connect(ctx.destination);
  }
  return ctx;
}

function tone({ freq, dur = 0.15, type = "sine", vol = 0.3, delay = 0, slideTo = null }) {
  const c = ensure();
  if (!c || muted) return;
  const t0 = c.currentTime + delay;
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  if (slideTo) osc.frequency.exponentialRampToValueAtTime(slideTo, t0 + dur);
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.exponentialRampToValueAtTime(vol, t0 + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(g);
  g.connect(master);
  osc.start(t0);
  osc.stop(t0 + dur + 0.05);
}

const MUSIC = [523.25, 659.25, 783.99, 659.25, 587.33, 783.99, 880.0, 659.25];

export const sound = {
  isMuted: () => muted,
  resume() {
    const c = ensure();
    if (c && c.state === "suspended") c.resume();
  },
  setMuted(m) {
    muted = m;
    localStorage.setItem("mathrush_muted", m ? "1" : "0");
    if (master) master.gain.value = m ? 0 : 0.5;
    if (m) this.stopMusic();
    else this.startMusic();
  },
  click() { tone({ freq: 320, dur: 0.06, type: "square", vol: 0.12 }); },
  correct() {
    tone({ freq: 660, dur: 0.12, type: "triangle", vol: 0.25 });
    tone({ freq: 990, dur: 0.16, type: "triangle", vol: 0.22, delay: 0.09 });
  },
  wrong() { tone({ freq: 220, dur: 0.22, type: "sine", vol: 0.22, slideTo: 140 }); },
  special() {
    [523, 659, 784, 1046].forEach((f, i) =>
      tone({ freq: f, dur: 0.18, type: "triangle", vol: 0.24, delay: i * 0.06 }));
  },
  win() {
    [523, 659, 784, 1046, 1318].forEach((f, i) =>
      tone({ freq: f, dur: 0.24, type: "triangle", vol: 0.26, delay: i * 0.11 }));
  },
  startMusic() {
    if (muted || musicTimer) return;
    const c = ensure();
    if (!c) return;
    musicStep = 0;
    musicTimer = setInterval(() => {
      const note = MUSIC[musicStep % MUSIC.length];
      tone({ freq: note, dur: 0.4, type: "sine", vol: 0.07 });
      tone({ freq: note / 2, dur: 0.5, type: "triangle", vol: 0.05 });
      musicStep++;
    }, 460);
  },
  stopMusic() {
    if (musicTimer) { clearInterval(musicTimer); musicTimer = null; }
  },
};
